<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户中心</el-breadcrumb-item>
        <el-breadcrumb-item>常用联系人</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="sidebar">
        <div class="avatar">
          <img src="../../assets/images/avatar.jpg" />
          <div class="name">
            <!--<h3>张明翰</h3>-->
            <p>{{ phoneNumShow() }}</p>
          </div>
        </div>
        <ul class="menu">
          <li>
            <router-link to="/account/ticket-order">
              <img src="../../assets/images/icon-ticket.png" />
              <span>票务订单</span>
            </router-link>
          </li>
          <li>
            <router-link to="/account/mall-order">
              <img src="../../assets/images/icon-order.png" />
              <span>商城订单</span>
            </router-link>
          </li>
          <li class="active">
            <router-link to="/account/contacts">
              <img src="../../assets/images/icon-contacts-active.png" />
              <span>常用联系人</span>
            </router-link>
          </li>
          <!--
          <li>
            <router-link to="/account/profile">
              <img src="../../assets/images/icon-profile.png" />
              <span>个人资料</span>
            </router-link>
          </li>-->
        </ul>
      </div>
      <div class="main">
        <div class="main-title">
          <h2>常用联系人</h2>
          <el-button type="text" @click="toAddContact()">+ 添加游客</el-button>
        </div>
        <ul class="contacts-list">
          <li v-for="item in contactList" :key="item.id">
            <h3>
              {{ item.username }}<i>|</i
              ><span>{{ item.contact_type == 0 ? '成人' : '儿童' }}</span>
            </h3>
            <p>{{ IDTypeName(item.id_type) }}</p>
            <p>{{ filterIDNumber(item.id_type, item.id_number) }}</p>
            <div class="edit">
              <img
                @click="toAddContact(item)"
                src="../../assets/images/icon-edit.png"
              />
              <img
                @click="deleteContact(item.id)"
                src="../../assets/images/icon-delete.png"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog :title="addContactTitle" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-width="140px">
        <el-form-item label="姓名" required>
          <el-input
            v-model="form.name"
            autocomplete="off"
            placeholder="请输入真实姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" required>
          <el-radio-group
            v-model="form.contactType"
            @change="contactTypeChange"
          >
            <el-radio label="0">成人</el-radio>
            <el-radio label="1">儿童</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证件类型" required>
          <el-select
            v-model="form.idTypeName"
            placeholder="请选择证件类型"
            @change="idTypeChange"
          >
            <el-option
              v-for="cItem in certificateTypeList"
              :key="cItem.value"
              :label="cItem.name"
              :value="cItem.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" required>
          <el-input
            v-model="form.idNumber"
            autocomplete="off"
            placeholder="请输入证件号码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd">取消</el-button>
        <el-button type="primary" @click="confirmAdd">{{
          saveButtonName()
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="退票提示"
      :visible.sync="contanctDialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <p>您确定要删除该联系人吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contanctCancel">取消</el-button>
        <el-button type="primary" @click="contanctConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import user from '@/api/user';
import {
  IDNumberFilter,
  regexs,
  checkIDNumber,
  phoneHidden,
} from '@/setup/common';
import constValuesConfig from '@/setup/constantConfig';
import users from '@/setup/user';
import routerTo from '@/router/routerTo';
export default {
  data() {
    return {
      dialogFormVisible: false,
      contanctDialogVisible: false,
      form: {
        contactId: '',
        name: '',
        gender: '1',
        contactType: '0',
        idType: '',
        idTypeName: '',
        idNumber: '',
      },
      edit: 0,
      addContactTitle: '添加联系人',
      contactList: [],
      certificateTypeList: constValuesConfig.ID,
      delectContanctId: '',
    };
  },
  created() {
    this.getContactList();
  },
  methods: {
    handleClose() {
      this.contanctDialogVisible = false;
    },
    async getContactList() {
      const contactListGet = await user.getContactList({});
      this.contactList = contactListGet;
    },
    deleteContact(contanctId) {
      this.contanctDialogVisible = true;
      this.delectContanctId = contanctId;
    },
    goToContacts() {
      routerTo.toContacts(this.$router, false);
    },
    contactTypeChange(e) {
      //性别切换
      console.log(e);
      this.form.contactType = e;
    },
    contanctCancel() {
      this.contanctDialogVisible = false;
    },
    async contanctConfirm() {
      const delectContanctList = await user.deleteContact({
        id: this.delectContanctId,
      });
      this.contanctDialogVisible = false;
      for (var i = 0; i < this.contactList.length; i++) {
        if (this.contactList[i].id == this.delectContanctId) {
          this.contactList.splice(i, 1);
        }
      }
    },
    idTypeChange(event) {
      //证件类型切换
      this.form.idType = event;
      this.certificateTypeList.forEach((item) => {
        if (item.value == this.form.idType) {
          this.form.idTypeName = item.name;
        }
      });
    },
    saveButtonName() {
      return this.edit == 0 ? '确 定' : '保 存';
    },
    cancelAdd() {
      this.dialogFormVisible = false;
    },
    confirmAdd() {
      if (!this.form.name) {
        alert('请输入联系人姓名');
        return;
      }
      if (!this.form.idTypeName.length) {
        alert('请选择证件类型');
        return;
      }
      if (!this.form.idNumber) {
        alert('请输入证件号码');
        return;
      }
      if (this.form.idType == constValuesConfig.IDCode.ID) {
        if (!checkIDNumber(this.form.idNumber)) {
          alert('请输入正确的身份证号码');
          return null;
        }
      } else if (this.form.idType == constValuesConfig.IDCode.Passport) {
        if (!regexs.passport.test(this.form.idNumber)) {
          alert('请输入正确的护照号码');
          return null;
        }
      } else if (this.form.idType == constValuesConfig.IDCode.HMPassport) {
        if (!regexs.HMPassport.test(this.form.idNumber)) {
          alert('请输入正确的港澳通行证号码');
          return null;
        }
      } else if (this.form.idType == constValuesConfig.IDCode.TPassport) {
        if (!regexs.TWPassport.test(this.form.idNumber)) {
          alert('请输入正确的台胞证号码');
          return null;
        }
      }
      if (this.edit == 0) {
        this.addContact();
      } else if (this.edit == 1) {
        this.editContact();
      }
    },
    async addContact() {
      let currentUser = users.getUser();
      // console.log(currentUser.phone);
      const contactData = await user.addContact({
        username: this.form.name,
        phone: currentUser.phone,
        certificate_type: this.form.idType,
        certificate_id: this.form.idNumber,
        contact_type: this.form.contactType,
      });
      this.dialogFormVisible = false;
      this.getContactList();
    },
    async editContact() {
      let currentUser = users.getUser();
      const contactData = await user.editContact({
        id: this.form.contactId,
        username: this.form.name,
        phone: currentUser.phone,
        id_type: this.form.idType,
        id_number: this.form.idNumber,
        contact_type: this.form.contactType,
      });
      this.dialogFormVisible = false;
      this.getContactList();
    },
    filterIDNumber(id_type, idNumber) {
      return IDNumberFilter(id_type, idNumber);
    },
    IDTypeName(idType) {
      let idName = '';
      this.certificateTypeList.forEach((item) => {
        if (item.value == idType) {
          idName = item.name;
        }
      });
      return idName;
    },
    phoneNumShow() {
      let currentUser = users.getUser();
      if (currentUser != null) {
        let phone = phoneHidden(currentUser.phone);
        return phone;
      }
    },
    toAddContact(contanctItem) {
      this.dialogFormVisible = true;
      this.form.name = '';
      this.form.contactId = '';
      this.form.name = '';
      this.form.gender = '';
      this.form.contactType = '0';
      this.form.idNumber = '';
      if (contanctItem) {
        this.edit = 1;
        this.addContactTitle = '编辑联系人';
        this.form.contactId = contanctItem.id;
        this.form.name = contanctItem.username;
        this.form.gender = JSON.stringify(contanctItem.gender);
        this.form.contactType = JSON.stringify(contanctItem.contact_type);
        this.form.idNumber = contanctItem.id_number;
        constValuesConfig.ID.forEach((item) => {
          if (item.value == contanctItem.id_type) {
            this.form.idType = contanctItem.id_type;
            this.form.idTypeName = item.name;
          }
        });
      } else {
        this.edit = 0;
        this.addContactTitle = '添加联系人';
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrapper {
  display: flex;
  justify-content: space-between;
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  text-align: left;
}
.sidebar {
  width: 280px;
  padding: 20px 0;
  border-radius: 10px;
  background: #fff;
  .avatar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 30px;
    .name {
      margin-left: 16px;
      h3 {
        margin-bottom: 5px;
        font-size: 18px;
      }
    }
  }
  .menu {
    li {
      height: 50px;
      padding: 0 0 0 30px;
      font-size: 16px;
      line-height: 50px;
      a {
        display: block;
        color: #191b26;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
    li.active {
      border-right: 2px solid #31a775;
      color: #31a775;
      background: #f6fcf9;
      a {
        color: #31a775;
      }
    }
  }
}
.main {
  width: 800px;
  .main-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    line-height: 40px;
    h2 {
      border-bottom: 2px solid #31a775;
      color: #31a775;
      font-weight: normal;
      font-size: 16px;
    }
    .el-button--text {
      color: #31a775;
      font-size: 16px;
    }
  }
  .contacts-list {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 250px;
      margin: 0 16px 10px 0;
      padding: 20px 20px;
      position: relative;
      border-radius: 10px;
      line-height: 22px;
      background: #fff;
      h3 {
        margin-bottom: 10px;
        color: #191b26;
        font-size: 16px;
        i {
          margin: 0 10px;
          font-weight: normal;
        }
        span {
          font-weight: normal;
          font-size: 14px;
        }
      }
      p {
        color: #515457;
      }
      .edit {
        position: absolute;
        top: 20px;
        right: 20px;
        a {
          margin-left: 10px;
        }
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
/deep/ .el-dialog {
  width: 560px;
  border-radius: 10px;
  text-align: left;
  .el-form {
    width: 440px;
  }
  .el-dialog__title {
    font-size: 16px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #31a775;
    background: #31a775;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #31a775;
  }
  .el-button--primary {
    border-color: #31a775;
    background-color: #31a775;
  }
}
</style>
